import LazyLoad, { ILazyLoadInstance, ILazyLoadOptions } from 'vanilla-lazyload';
import { getImageInfo, changeToResponsiveImage } from './helper/lazyinit';

window.initOnLazyLoad = (el, instance) => {
    if (el.hasAttribute('data-tail-id')) {
        if (
            document.body.hasAttribute('data-tail-src') &&
            el.hasAttribute('data-tail-id') &&
            !el.classList.contains('tail')
        ) {
            changeToResponsiveImage(el);
            instance.update();
            LazyLoad.resetStatus(el);
        }
    }
};

window.setImageSize = (el, instance) => {
    if (!el?.classList.contains('tail-originalsize')) {
        const {imageWidth, imageHeight, codedValues} = getImageInfo(el);

        if (imageWidth > 0) {
            el?.setAttribute('width', imageWidth);
        }
        if (imageHeight > 0) {
            el?.setAttribute('height', imageHeight);
        }
    }
};

window.lazyLoadInstance = new LazyLoad({
    elements_selector: '[data-src]',
    unobserve_completed: true, // set to false if you need tracking if the image leaves the screen
    callback_loading: window.initOnLazyLoad,
    callback_loaded: window.setImageSize
});